import React, { useState } from 'react';
import FeedbackButton from './FeedbackButton';
import FeedbackPanel from './FeedbackPanel';

const CustomerFeedback: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <FeedbackButton onClick={handleOpen} />
      <FeedbackPanel isOpen={isOpen} onClose={handleClose} />
    </>
  );
};

export default CustomerFeedback;

